<template>
	<div class="dropdown">

		<FormKit
			type="select"
			:label="label"
			v-bind="$attrs"
			data-testid="dropdownSingleSelect"
			:class="[
				{ 'is-active': showOptions },
				{ errorState: 'is-error' },
				{ 'is-placeholder': !value || value === placeholder },
				$attrs.class
			]"
			v-model="value"
		>
			<option
				v-for="(item, index) in options"
				:key="item.key"
				:value="item.key || ''"
			>
				{{ item.value || item.key }}
			</option>
		</FormKit>
		<div>
			{{ $attrs }}
		</div>
	</div>
</template>

<script>
import { FormKit } from '@formkit/vue';

export default {
	name: "DropdownSingleSelect",
	components: {
		FormKit,
	},
	props: {
		options: [Array, { key: String, value: String }],
		placeholder: {
			type: String,
			default: "Choose Option",
		},
		errorState: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: "Choose option",
		},
		buttonId: {
			type: String,
			default: "dropdown-button",
		},
		labelId: {
			type: String,
			default: "dropdown-label",
		},
		preSelected: {
			default: null,
		},
		readOnly: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			showOptions: false,
			chosenIndex: null,
			value: null,
			key: null,
		};
	},
	emits: ['keyChosen'],
	watch: {
		value(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.$emit("keyChosen", newVal);
			}
		},
	},
	mounted() {
		if (this.preSelected !== null) {
			this.value = this.preSelected;
		}
	},
};
</script>

<style lang="scss" scoped>
.show-error {
	:deep(.formkit-inner) {
		border-color: var(--ds-color-fg-default);
		box-shadow: 0 0 0 var(--fk-border-width) var(--ds-color-border-danger);
	}
}
.dropdown :deep(.formkit-inner select) {
	border: none;
}
</style>
